import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrderTransactionApi } from "../../../../../../../../../services/Api/Public/types";

interface Props {
	totalPrice: MoneyApi;
	handlePay: (
		paymentData: string,
		callback?: (data: OrderTransactionApi) => Promise<void> | void
	) => (e?: React.BaseSyntheticEvent) => Promise<void>;
	validatePaymentDataOnClick: () => boolean;
	checkTransaction: (data: OrderTransactionApi) => Promise<void>;
}

const CustomPayButton = ({ totalPrice, handlePay, validatePaymentDataOnClick, checkTransaction }: Props) => {
	const { t } = useTranslation();

	const handleOnClick = async () => {
		if (!validatePaymentDataOnClick()) return;

		await handlePay("", checkTransaction)();
	};

	return (
		<Button onClick={handleOnClick} data-testid="e-order-custom-pay-button">{`${t(
			"modules.e_order.action.pay.title"
		)}: ${FormatMoney(totalPrice)}`}</Button>
	);
};

export default CustomPayButton;
